import { Link } from "react-router-dom"
import GuestLayout from "../components/GuestLayout"

const NotFound = () => {
  const handleResetCache = async () => {
    localStorage.clear()
  }

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <main className="w-75 mx-auto">
        <div id="login" className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <div className="card rounded-4 shadow-none">
              <div className="card-body p-5">
                <div className="mb-5">
                  <h1 className="text-body-emphasis fw-bold m-0">404</h1>
                  <p className="lead text-body-secondary fw-bold m-0">Page Not Found</p>
                  <p className="text-body-secondary m-0">The page you are looking for is no longer available.</p>
                </div>
                <p className="text-body-tertiary m-0">Some reasons why this page shown up might be:</p>
                <ul className="text-body-tertiary m-0">
                  <li>This page was removed and other pages still link to it</li>
                  <li>Our server may be experiencing technical difficulties</li>
                  <li>You typed an incorrect address in your browser's address bar</li>
                </ul>
                <div className="d-flex gap-2 justify-content-center mt-5">
                  <button type="button" className="btn btn-light-danger w-25" onClick={handleResetCache}>Reset Cache</button>
                  <Link to="/" className="btn btn-light-theme w-25">Home</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3"></div>
        </div>
      </main>
    </GuestLayout>
  )
}

export default NotFound